module.exports = __webpack_public_path__ + "static/media/part3_2.1dc20e6f.webp";